export enum PersonConfigFileType {
  identityPiece = 'identity_piece',
  other = 'other'
}
